export const productTypes = [
  { label: 'TQ', value: 'tq' },
  { label: 'SKT', value: 'skt' },
  { label: 'JHARKHAND', value: 'jharkhand' },
]
